export default __webpack_public_path__ + "static/media/Soundbar.6434cdad.png";